export enum dateValidationError {
  maxDate = 'maxDate',
  minDate = 'minDate',
  invalidDate = 'invalidDate',
  disableFuture = 'disableFuture',
}
